import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgViewLittle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M12.284 12.305H5.625v-6.68h6.66zm0 10.02H5.625v-6.68h6.66zm0 10.021H5.625v-6.68h6.66zm10.031-20.041h-6.66v-6.68h6.66zm0 10.02h-6.66v-6.68h6.66zm0 10.021h-6.66v-6.68h6.66zm3.37-26.721h6.659v6.68h-6.659zm0 10.02h6.659v6.68h-6.659zm0 10.02h6.659v6.68h-6.659zm10.031-20.04h6.659v6.68h-6.659zm0 10.02h6.659v6.68h-6.659zm0 10.02h6.659v6.68h-6.659zM12.284 42.366H5.625v-6.68h6.66zm10.031 0h-6.66v-6.68h6.66zm10.03 0h-6.659v-6.68h6.66zm3.371-6.681h6.659v6.68h-6.659z" }) }) })
});
export default SvgViewLittle;
